<template>
    <div class="merchant-routing-rule">
        <div class="merchant-routing-rule__contents">
            <div class="merchant-routing-rule__header">
            <h1>vNUBAN Routing Setup</h1>
            <p>Be sure to enter the right bank account information</p>
            </div>
            <div>
                <div class="space-down">
                <Dropdown title="Collection Bank" label="Select bank" :options="bankList.length ? getBanksWithRules(bankList) : []" :onOptionSelected="({ id }) => state.selected.bank_code = id" />
                </div>
                <div class="space-down">
                    <Dropdown disabled title="Rule Type" label="Specific" :options="bankList.length ? bankList : []" :onOptionSelected="({ id }) => state.selected.bank_code = id" />
                </div>
                <div class="space-down submit">
                    <Button :disabled="contents.isSettingMerchantSpecificRule"  buttonName="Submit Settings" :onClick="handleCreateSpecificRule" classes="primary"  />
                </div>
            </div>
        </div>
        <div class="footer"></div>
    </div>
    
</template>
<script>
import Dropdown from "@/components/dropdown"
import Button from "@/components/button.vue"
import { reactive, onBeforeMount, computed, watch } from '@vue/composition-api'

export default {
  components: {
      Dropdown,
      Button
  },
    setup(props, { root }) {
        const store = root.$store;
        const params = root.$route.params;

       const bankList = computed(() => store.getters.getBankListKeyAndValuePair);
       const contents = computed(() => store.getters.getMerchantRoutingRules);

        const state = reactive({
            selected: {
              bank_code: '',
            }
        })

        const handleCreateSpecificRule = () => {
            store.dispatch('setSpecificRoutingRules', { ...state.selected, merchant_id: params.id })
        }

        const getBanksWithRules = banks => banks.filter(({ rule_applied }) =>  rule_applied === true)

        return {
            state,
            bankList,
            handleCreateSpecificRule,
            contents,
            getBanksWithRules
        }

    }
}
</script>
<style lang="scss">
.merchant-routing-rule {
    display: flex;
    flex-direction: column;

    &__header {
        h1 {
            /*font-family: 'lato-regular';*/
            font-style: italic;
            font-weight: normal;
            font-size: 18px;
            line-height: 22px;
            color: #261940;
            margin-bottom: 14px;
        }

        p {
            /*font-family: 'lato-regular';*/
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 24px;
            color: #261940;
            opacity: 0.7;
            width: 267px;
        }
    }

    &__contents {
        display: flex;
        justify-content: space-between;
        padding: 58px 130px;
    }

    .submit {
        .btn {
            height: 51px;
            justify-content: center;

            .btn--text {
                /*font-family: 'lato-regular';*/
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 26px;
                text-align: center;
            }
        }
    }

    .space-down {
        margin-bottom: 32px;
    }

    .drop-down, .btn {
        width: 386px;
    }

    .dropdown-options {
       width: 386px;
    }

    .footer {
        height: 86px;
        border-top: 1px solid #EBF0F4;
    }
}
</style>